import React, { useLayoutEffect, useRef } from 'react';
import { useProfile } from '../context/ProfileContext';
import './ProfileBanner.css';

const ProfileBanner = () => {
    const { isOwnProfile, viewedUserName, clearViewedUser } = useProfile();
    const bannerRef = useRef(null);

    // Aktuell sichtbare Höhe des Banners veröffentlichen — Editor-Werkzeugleiste
    // und Kommandobrücke kleben darunter (analog --app-header-offset in Header.js).
    // Läuft auch beim Wechsel zurück zum eigenen Profil: die Cleanup-Funktion
    // entfernt die Variable dann sofort, statt erst beim Unmount — der Banner
    // wird ja nur ausgeblendet (return null), nicht unmounted.
    useLayoutEffect(() => {
        if (isOwnProfile) {
            document.documentElement.style.removeProperty('--profile-banner-offset');
            return undefined;
        }
        const el = bannerRef.current;
        if (!el) return undefined;
        const anwenden = () => {
            // getBoundingClientRect().height statt offsetHeight: offsetHeight rundet auf
            // ganze Pixel und hinterlässt einen Subpixel-Spalt zur darunter angedockten Leiste.
            document.documentElement.style.setProperty('--profile-banner-offset', `${el.getBoundingClientRect().height}px`);
        };
        anwenden();
        const beobachter = new ResizeObserver(anwenden);
        beobachter.observe(el);
        return () => {
            beobachter.disconnect();
            document.documentElement.style.removeProperty('--profile-banner-offset');
        };
    }, [isOwnProfile]);

    if (isOwnProfile) {
        return null; // Kein Banner für eigenes Profil
    }

    return (
        <div className="profile-banner" ref={bannerRef}>
            <div className="profile-banner-content">
                <span className="profile-banner-icon">👁️</span>
                <span className="profile-banner-text">
                    Du siehst das Profil von <strong>{viewedUserName}</strong>
                </span>
                <button 
                    className="profile-banner-button"
                    onClick={clearViewedUser}
                >
                    Zurück zu deinem Profil
                </button>
            </div>
        </div>
    );
};

export default ProfileBanner;
